module.exports = __webpack_public_path__ + "img/Porto Apartment - 28 of 85.3fa8bb34.jpeg";